import { resolveSafeRedirectPath } from '@rumah-pendidikan/auth/react'

export function resolveLoginRedirectPath(search: string): string {
  const searchParams = new URLSearchParams(search)
  const redirectPath =
    searchParams.get('redirect') ||
    searchParams.get('to') ||
    searchParams.get('from')

  return resolveSafeRedirectPath(redirectPath, '/')
}
